import type { ProfileResponse } from 'entities/user/types';

export const hasFullName = (profile: ProfileResponse | null | undefined): boolean =>
  Boolean(profile?.first_name?.trim() && profile?.last_name?.trim());

/**
 * A self-signup whose company was created without a name — the Auth0 form's `company_name` claim
 * never reached the backend. Only someone who can edit company settings is asked, since only they can save it.
 */
export const needsCompanyName = (profile: ProfileResponse | null | undefined): boolean =>
  Boolean(
    profile?.company && !profile.company.name?.trim() && profile.permissions.includes('can_edit_company_settings'),
  );

export const isProfileComplete = (profile: ProfileResponse | null | undefined): boolean =>
  hasFullName(profile) && !needsCompanyName(profile);
